import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const bmsMdSideNav = {
  id: 'md',
  children: [
    {
      id: 'mdGpoMenu',
      displayName: 'GPO',
      role: 'MD_CUST_VIEW',
      icon: fas.faChartBar,
      children: [
        {
          id: 'mdGpoRosterDashboard',
          displayName: 'GPO Roster Dashboard',
          role: 'MD_CUST_VIEW',
          icon: fas.faChartBar,
          route: '/md/gpo-roster-dashboard',
        },
      ],
    },
  ],
};

export default bmsMdSideNav;
